/**
 * @flow
 * @relayHash b06cecb0fc2b6c2a15f3a52a47a5cbda
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TVShow_viewer$ref = any;
export type queries_TVShowQueryVariables = {|
  id: string,
  section: string,
|};
export type queries_TVShowQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TVShow_viewer$ref
  |}
|};
export type queries_TVShowQuery = {|
  variables: queries_TVShowQueryVariables,
  response: queries_TVShowQueryResponse,
|};
*/


/*
query queries_TVShowQuery(
  $id: ID!
  $section: ID!
) {
  viewer {
    ...TVShow_viewer_2ftqWg
    id
  }
}

fragment TVShow_viewer_2ftqWg on Viewer {
  id
  tvshow(id: $id) {
    id
    title
    slug
    previewPicture
    isProject
    hideDescription
    preview {
      id
      filename
    }
    shortDescription
    description
    schedule
    category
    persons {
      id
      firstName
      lastName
      smallAvatar
    }
    state
    order
  }
  categories(section: $section) {
    edges {
      node {
        id
        name
      }
    }
  }
  persons(first: -1, personType: "host") {
    edges {
      node {
        id
        firstName
        lastName
        smallAvatar
      }
    }
  }
  me {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "firstName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "lastName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "smallAvatar",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_TVShowQuery",
  "id": null,
  "text": "query queries_TVShowQuery(\n  $id: ID!\n  $section: ID!\n) {\n  viewer {\n    ...TVShow_viewer_2ftqWg\n    id\n  }\n}\n\nfragment TVShow_viewer_2ftqWg on Viewer {\n  id\n  tvshow(id: $id) {\n    id\n    title\n    slug\n    previewPicture\n    isProject\n    hideDescription\n    preview {\n      id\n      filename\n    }\n    shortDescription\n    description\n    schedule\n    category\n    persons {\n      id\n      firstName\n      lastName\n      smallAvatar\n    }\n    state\n    order\n  }\n  categories(section: $section) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  persons(first: -1, personType: \"host\") {\n    edges {\n      node {\n        id\n        firstName\n        lastName\n        smallAvatar\n      }\n    }\n  }\n  me {\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_TVShowQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TVShow_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_TVShowQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tvshow",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID"
              }
            ],
            "concreteType": "TVShow",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "previewPicture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isProject",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hideDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "preview",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "filename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shortDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "schedule",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "category",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "persons",
                "storageKey": null,
                "args": null,
                "concreteType": "Person",
                "plural": true,
                "selections": v2
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "order",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "CategoryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "persons",
            "storageKey": "persons(first:-1,personType:\"host\")",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "personType",
                "value": "host",
                "type": "String"
              }
            ],
            "concreteType": "PersonConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PersonEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Person",
                    "plural": false,
                    "selections": v2
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v1
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '857b3d6134d6fa814bab1e2ed9fac4ed';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_TVShowQuery.graphql.js